import React, { useState } from 'react';
import ReadMore from '@components/shared/ReadMore/ReadMore';

interface IReadMoreContainer {
  text: string;
  className?: string;
  contentClassName?: string;
}

const ReadMoreContainer = ({
  text,
  className = '',
  contentClassName = '',
}: IReadMoreContainer) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <ReadMore
      className={className}
      contentClassName={contentClassName}
      expanded={expanded}
      setExpanded={setExpanded}
    >
      <div>
        {text}
      </div>
    </ReadMore>
  );
};

export default ReadMoreContainer;
